import { useState } from "react";

export default function AddressBar() {
  const [copied, setCopied] = useState(false);
  const address = "www.1heiliaowang.live";

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  };

  return (
    <section className="w-full -mt-2">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-center gap-4 rounded-xl border border-background-200/70 bg-background-50 p-4 md:p-5">
          <div className="flex items-center gap-3 lg:w-64 shrink-0">
            <span className="grid place-items-center h-11 w-11 shrink-0 rounded-lg bg-accent-500 text-background-50">
              <i className="ri-link text-xl"></i>
            </span>
            <div>
              <p className="text-sm font-bold text-foreground-950">1黑料网 · 直达地址</p>
              <p className="flex items-center gap-1.5 text-[11px] text-foreground-500">
                <span className="h-1.5 w-1.5 rounded-full bg-accent-500 animate-pulse"></span>
                入口当前可用 · 建议收藏
              </p>
            </div>
          </div>

          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 rounded-lg border border-background-300/60 bg-background-100/70 px-4 py-2.5">
              <i className="ri-lock-2-line text-secondary-600 shrink-0"></i>
              <span className="truncate font-mono text-sm md:text-[15px] text-foreground-900 tracking-wide">{address}</span>
            </div>
            <p className="mt-1.5 text-[11px] text-foreground-500">
              收藏本页即可一键找到 1黑料网 首页入口；若地址变动，会第一时间更新到上方导航与「找地址」专区。
            </p>
          </div>

          <div className="flex items-center gap-2 shrink-0">
            <button
              type="button"
              onClick={handleCopy}
              className={`whitespace-nowrap inline-flex items-center gap-1.5 rounded-md px-4 py-2.5 text-sm font-semibold transition-colors cursor-pointer ${
                copied ? "bg-accent-500 text-background-50" : "bg-primary-500 text-background-50 hover:bg-primary-600"
              }`}
            >
              <i className={copied ? "ri-check-double-line" : "ri-file-copy-line"}></i>
              {copied ? "已复制地址" : "复制直达地址"}
            </button>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              aria-label="收藏"
              className="grid place-items-center h-[42px] w-[42px] rounded-md border border-background-300/70 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <i className="ri-bookmark-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}